import React, {forwardRef, useMemo} from 'react'
import PropTypes from 'prop-types'
import {Text, useRecipe} from '@chakra-ui/react3'
import {useAgeRange} from '../../../hooks/use-age-range'
import ageRangeRecipe from './index.recipe'

const AgeRange = forwardRef(({css, product, variant, ...props}, ref) => {
    const recipe = useRecipe({recipe: ageRangeRecipe})
    const styles = useMemo(() => recipe({variant}), [recipe, variant])
    const ageRangeText = useAgeRange(
        product?.c_suitableFromAgeinMonths,
        product?.c_suitableToAgeinMonths
    )

    if (!ageRangeText) return null

    return (
        <Text ref={ref} {...props} css={[styles, css]}>
            {ageRangeText}
        </Text>
    )
})

if (process.env.NODE_ENV !== 'production') {
    AgeRange.displayName = 'AgeRange'
}

AgeRange.propTypes = {
    css: PropTypes.object,
    product: PropTypes.object,
    variant: PropTypes.string
}

export default AgeRange
